import { auth as authFB } from '@/helpers/firebase';
import authApi from '@/services/auth';
import storage from '@/helpers/storage';
import moment from 'moment';
import { event } from 'vue-analytics';
const actions = {
    async login({ commit, dispatch }) {
        commit('setState', 'stores.auth.loadingFirebase');
        // ======= get current firebase user, if any ======= \\
        let fbUser = null;
        try {
            fbUser = await dispatch('getFBUser');
        }
        catch (err) {
            commit('setState', 'stores.auth.loadingError', err);
            throw err;
        }
        // ======= get current firebase user, if any, from redirect response ======= \\
        if (!fbUser) {
            try {
                fbUser = await dispatch('getFBRedirectResult');
            }
            catch (err) {
                commit('setState', 'stores.auth.loadingError', err);
                throw err;
            }
        }
        if (!fbUser) {
            commit('clearState');
            throw 'need_login';
        }
        commit('setFBUser', fbUser);
        // ======= get firebase token from user ======= \\
        let fbToken = null;
        commit('setState', 'stores.auth.loadingFirebaseToken');
        try {
            fbToken = await fbUser.getIdToken(true);
        }
        catch (err) {
            throw err;
        }
        if (!fbToken) {
            commit('clearState');
            throw 'need_login';
        }
        commit('setFBToken', fbToken);
        // ======= get backend token ======= \\
        commit('setState', 'stores.auth.loadingBackendUserToken');
        let beInfo = null;
        try {
            beInfo = await dispatch('getBEUserInfo');
        }
        catch (err) {
            throw err;
        }
        if (!beInfo) {
            commit('clearState');
            throw 'need_login';
        }
        commit('setBEInfo', beInfo);
        // monitor sessionState
        dispatch('sessionMonitor');
        commit('clearState');
        return true;
    },
    // repeat auto login 2 hours before token expires
    sessionMonitor({ state, dispatch }) {
        setInterval(() => {
            const secondsRemaining = state.sessionTimeoutUnix - moment().unix();
            if (secondsRemaining < (60 * 60 * 2)) {
                dispatch('login');
            }
        }, 5000);
    },
    getFBUser() {
        return new Promise((resolve, reject) => {
            if (authFB.currentUser)
                resolve(authFB.currentUser);
            const unsubscribe = authFB.onAuthStateChanged(user => {
                unsubscribe();
                resolve(user);
            }, reject);
        });
    },
    async getFBRedirectResult() {
        try {
            const res = await authFB.getRedirectResult();
            return res.user;
        }
        catch (err) {
            throw err;
        }
    },
    getBEUserInfo() {
        return authApi.login();
    },
    async updateAccount(info) {
        event('auth-store', 'action-updateAccount');
        return authApi.login(info);
    },
    async updateEmail({ state }, { newEmail, password }) {
        try {
            if (!state.fbUser)
                throw 'no_user';
            const usr = await authFB.signInWithEmailAndPassword(String(state.fbUser.email), password);
            if (!usr.user)
                throw 'no_user';
            event('auth-store', 'action-updateAccount');
            await usr.user.updateEmail(newEmail);
        }
        catch (err) {
            throw err;
        }
        return true;
    },
    async updateFbProfile({ state }, profile) {
        if (!state.fbUser)
            return;
        event('auth-store', 'action-updateFbProfile');
        return await state.fbUser.updateProfile(profile);
    },
    wait({ commit }, dur) {
        return new Promise((resolve) => {
            setTimeout(() => resolve(), dur);
        });
    },
    async logout({ commit, dispatch }) {
        commit('logout');
        try {
            await authFB.signOut();
            storage.clear();
            dispatch('gotoDBTrackWeb', null, { root: true });
        }
        catch (err) {
            console.log(err);
            throw err;
        }
    },
    async deleteProfile({ dispatch, commit }, profileID) {
        event('auth-store', 'action-deleteProfile', '', profileID);
        await authApi.deleteProfile(profileID);
        // wont exec if err thrown
        commit('removeProfile', profileID);
    },
    async deleteAccount({ dispatch, state }) {
        event('auth-store', 'action-deleteAccount');
        if (!state.account)
            return;
        await authApi.deleteAccount(state.account.id);
        // wont exec if err thrown
        dispatch('logout');
        return true;
    }
};
export default actions;
